var ua = window.navigator.userAgent;
var vers;
var env = {}
var regexp = {
  // eslint-disable-next-line
  ios: /OS ([\d_\.]+) like Mac OS X/,
  // eslint-disable-next-line
  android: /Android[\s\/]([\d\.]+)/
}
if (ua.match(regexp.ios)) {
  vers = ua.match(regexp.ios)
  env.os = {
    name: 'IOS',
    isIOS: !0,
    version: vers[1].split('_').join('.')
  }
} else if (ua.match(regexp.android)) {
  // eslint-disable-next-line
  vers = ua.match(regexp.android)
  env.os = {
    name: 'Android',
    isAndroid: !0,
    version: vers[1]
  }
} else {
  env.os = {name: 'unknown', version: '0.0.0'}
}

var loading = {
  html: '',
  css3: false,
  svg: false,
  canvas: false,
  normal: false,
  version: env.os.version,
  // 元素缩放比
  scale: 1,
  timer: null,
  _normalHtml: function () {
    this.html += '<div class="loading-circle">';
    this.html += '<div class="loading-half-circle"></div>';
    this.html += '</div>';
  },
  _css3Html: function () {
    this.html += '<div class="loading-circle rotation-self">';
    this.html += '<div class="loading-half-circle rotation-clip"></div>';
    this.html += '</div>';
  },
  // css3对android 4.3及以下进行降级处理
  _css3CompatibleHtml: function () {
    this.html += '<div class="loading-circle circle-clip-auto">';
    this.html += '<div class="loading-half-circle rotation-self-360"></div>';
    this.html += '</div>';
  },
  _svgHtml: function () {
    this.html += '<svg class="loading-svg" width="80" height="80" xmlns="http://www.w3.org/2000/svg">';
    this.html += '<circle cx="40" cy="40" r="30" stroke="#FFF" fill="none" stroke-width="3" stroke-linecap="round">';
    this.html += '<animate attributeName="stroke-dashoffset" dur="1.6s" repeatCount="indefinite" from="427" to="45"></animate>';
    this.html += '<animate attributeName="stroke-dasharray" dur="1.6s" repeatCount="indefinite" values="121 70;1 190;121 70"></animate>';
    this.html += '</circle>';
    this.html += '</svg>';
  },
  _canvasHtml: function () {
    this.html += '<canvas id="loading-canvas" class="loading-canvas" width="80" height="80"></canvas>';
  },
  _normalInit: function () {
    // 进度条长度阀值
    var threshold = 0;
    // 定时器间隔时间
    var during = 20;
    // 每个during转动角度
    var angle = 8;
    // 进度条转动720度为一个周期,周期分为3个间隔
    // 第一个间隔,进度条长度增加
    // 第二个间隔,进度条长度不变
    // 第三个间隔,进度条长度减少
    var section = (720 / 3) / angle;

    var counter = 0;
    var rotateSelf = 0;
    var rotateHalf = 0;
    this.timer = window.setInterval(function () {
      counter++;
      if (counter <= section) {
        threshold += during;
        rotateHalf = (threshold / (during * section)) * 180;
      }
      if (counter >= section && counter <= section * 2) {
        rotateHalf = 180;
      }
      if (counter >= section * 2 && counter <= section * 3) {
        threshold -= during;
        rotateHalf = (180 - ((threshold / (during * section)) * 180)) + 180;
      }
      if (counter === section * 3) {
        threshold = 0;
        counter = 0;
        rotateHalf = 0;
      }
      rotateSelf = (counter / (3 * section)) * 540;

      document.getElementsByClassName('loading-circle')[0].style.transform = 'rotate(' + rotateSelf + 'deg)';
      document.getElementsByClassName('loading-circle')[0].style.WebkitTransform = 'rotate(' + rotateSelf + 'deg)';
      document.getElementsByClassName('loading-half-circle')[0].style.transform = 'rotate(' + rotateHalf + 'deg)';
      document.getElementsByClassName('loading-half-circle')[0].style.WebkitTransform = 'rotate(' + rotateHalf + 'deg)';
    }, during);
  },
  _canvasInit: function () {
    // 初始化canvas

    var canvas = document.getElementById('loading-canvas');
    var ctx = canvas.getContext('2d');

    var x = canvas.width / 2;
    var y = canvas.height / 2;

    // 解决IOS retina屏下绘制图像模糊
    var devicePixelRatio = window.devicePixelRatio || 1;
    var backingStoreRatio = ctx.webkitBackingStorePixelRatio ||
      ctx.mozBackingStorePixelRatio ||
      ctx.msBackingStorePixelRatio ||
      ctx.oBackingStorePixelRatio ||
      ctx.backingStorePixelRatio || 1;
    var ratio = devicePixelRatio / backingStoreRatio;
    if (devicePixelRatio !== backingStoreRatio) {
      var oldWidth = canvas.width;
      var oldHeight = canvas.height;
      canvas.width = oldWidth * ratio;
      canvas.height = oldHeight * ratio;
      canvas.style.width = oldWidth + 'px';
      canvas.style.height = oldHeight + 'px';
      ctx.scale(ratio, ratio);
    }
    // 解决IOS retina屏下绘制图像模糊

    // 进度条长度阀值
    var threshold = 0;
    // 定时器间隔时间
    var during = 15;
    // 每个during转动角度
    var angle = 6;
    // 进度条转动720度为一个周期,周期分为3个间隔
    // 第一个间隔,进度条长度增加
    // 第二个间隔,进度条长度不变
    // 第三个间隔,进度条长度减少
    var section = (720 / 3) / angle;
    var counter = 0;

    this.timer = window.setInterval(function () {
      counter++;
      // 第一个间隔,进度条长度增加
      if (counter <= section) {
        threshold += during;
      }
      // 第三个间隔,进度条长度减少
      if (counter >= section * 2 && counter <= section * 3) {
        threshold -= during;
      }
      // 一个周期结束,重置
      if (counter === section * 3) {
        threshold = 0;
        counter = 0;
      }
      rotate();
      drawArc();
    }, during);
    // 画布旋转angle角度
    function rotate () {
      ctx.translate(x, y);// 将绘图原点移到画布中点
      ctx.rotate((Math.PI / 180) * angle);// 旋转角度
      ctx.translate(-x, -y);// 将画布原点移动
    }

    // 在画布上画进度条
    function drawArc () {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.lineWidth = 3;
      ctx.strokeStyle = '#FFF';
      ctx.beginPath();
      ctx.arc(40, 40, 30, 1.5 * Math.PI, (threshold / (during * section) + 1.5) * Math.PI);
      ctx.stroke();
      ctx.closePath();
    }
  },
  // 在版本号ver及ver以下,如ver=4.4.4,则表示包含4.4.4及以下
  underVersion: function (ver) {
    if (this.compareVersion(this.version, ver) === '=') {
      return true;
    }
    if (this.compareVersion(this.version, ver) === '<') {
      return true;
    }
    return false;
  },
  // 获取viewport content中的参数
  getViewPortParam: function (name) {
    var viewport = document.querySelector('meta[name=viewport]');
    if (!viewport) {
      return null;
    }
    var content = viewport.getAttribute('content');
    if (!content) {
      return null;
    }
    // eslint-disable-next-line
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('(^|,)' + name + '=([^,]*)(,|$)', 'i');
    var results = regex.exec(content);

    return results === null ? null : decodeURIComponent(results[2].replace(/\+/g, ' '));
  },
  // 根据viewport设置放大倍数,默认为1
  setScale: function () {
    var initialScale = this.getViewPortParam('initial-scale') || 0;
    var maximumScale = this.getViewPortParam('maximum-scale') || 0;
    var minimumScale = this.getViewPortParam('minimum-scale') || 0;
    var scale = initialScale;
    if (maximumScale !== 0 && maximumScale <= initialScale) {
      scale = maximumScale;
    }
    if (minimumScale !== 0 && minimumScale >= initialScale) {
      scale = minimumScale;
    }
    this.scale = 1.0 / scale;
  },
  // 比较两个版本号
  compareVersion: function (curr, target) {
    if (curr === target) {
      return '=';
    }
    var currArr = curr.split('.');
    var targetArr = target.split('.');
    var len = currArr.length >= targetArr.length ? currArr.length : targetArr.length;

    for (var i = 0; i < len; i++) {
      if (!currArr[i]) {
        currArr[i] = 0;
      }
      if (!targetArr[i]) {
        targetArr[i] = 0;
      }

      if (currArr[i] > targetArr[i]) {
        return '>';
      } else if (currArr[i] < targetArr[i]) {
        return '<'
      }
    }

    return '=';
  },
  // 显示loading,共有4中实现方式 1、css3   2、js timer 3、svg  4、canvas
  show: function (options) {
    this.html = '';
    options = options || {};
    this.css3 = options.css3 || false;
    this.svg = options.svg || false;
    this.canvas = options.canvas || false;
    this.normal = options.normal || false;

    this.setScale();

    // 如果dom已存在,则不再重复添加
    var logoLoading = document.getElementsByClassName('logo-loading');
    if (logoLoading.length > 0) {
      console.log('dom已存在');
      return;
    }

    // 创建loading dom
    var div = document.createElement('div');
    div.className = 'logo-loading';
    if (env.os.isIOS) {
      // scale放大缩小会造成失真
      // div.style.transform = 'scale(' + this.scale + ')';
      // div.style.WebkitTransform = 'scale(' + this.scale + ')';
      div.style.zoom = this.scale;
    }
    if (this.css3) {
      this._css3Html();
    } else if (this.normal) {
      this._normalHtml()
    } else if (this.svg) {
      this._svgHtml();
    } else if (this.canvas) {
      this._canvasHtml();
    } else {
      if (env.os.isIOS) {
        this._canvasHtml();
      } else if (env.os.isAndroid && this.underVersion('4.3.0')) {
        this._css3CompatibleHtml();
      } else {
        this._css3Html();
      }
    }
    this.html += '<div class="logo-icon">';
    this.html += '<p></p> <p></p> <p></p> <p></p> <p></p> <p></p> <p></p>';
    this.html += '</div>';
    div.innerHTML = this.html;
    document.body.appendChild(div);
    var canvas = document.getElementById('loading-canvas');
    if (canvas) {
      this._canvasInit();
    }
    if (this.normal) {
      this._normalInit();
    }
  },
  // 隐藏loading
  hide: function () {
    var logoLoading = document.getElementsByClassName('logo-loading');
    if (logoLoading.length > 0) {
      var _element = logoLoading[0];
      _element.parentNode.removeChild(_element);
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }
  }
};
export default loading;



// WEBPACK FOOTER //
// ./packages/components/loading/loading-waiting.js